/*
* 未加 el-icon-loading
* */


import axios from "axios";
import Auth from "@/utils/Auth"; // 验权
import { Message, MessageBox } from "element-ui";

const HttpConnection = axios.create({
    baseURL: process.env.VUE_APP_PREFIX
});

HttpConnection.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

HttpConnection.interceptors.request.use(
    config => {
        let _token = Auth.getToken();
        if (_token) {
            config.headers["Authorization"] = _token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

HttpConnection.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code === 200) {
            return res;
        } else {
            MessageBox.alert(res.msg, "错误", {
                confirmButtonText: "确定",
                type: "error"
            });
            return Promise.reject("error");
        }
    },
    error => {
        Message({
            message: "连接超时（后台不能连接，请联系系统管理员）",
            type: "error",
            duration: 1 * 1000
        });
        return Promise.reject(error);
    }
);

export default HttpConnection;
